export default [
  {
    name: 'Dashboard',
    icon: 'fas fa-home',
    path: '/portal'
  },
  {
    name: 'Fileservice',
    icon: 'fas fa-copy',
    path: '/portal/fileservice'
  },
  {
    name: 'Credits',
    icon: 'fas fa-money-check-alt',
    path: '/portal/credits'
  },
  {
    name: 'Tickets',
    icon: 'fas fa-question-circle',
    path: '/portal/tickets'
  },
  {
    name: 'Transactions',
    icon: 'fas fa-hand-holding-usd',
    path: '/portal/transactions'
  },
  {
    name: 'Logout',
    icon: 'fas fa-sign-out-alt',
    path: '/logout'
  }
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js